export default __webpack_public_path__ + "static/media/client-4.55480100.webp";